const FAVORITES_KEY = 'shopify_local_favorites';

const WORKER_BASE_URL = 'https://shopify-wishlist.zmeng1980.workers.dev'

async function fetchLiveWishlist(customerId) {
  const requestUrl = `${WORKER_BASE_URL}/?customerId=${customerId}`;

  try {
    const response = await fetch(requestUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });

    const data = await response.json();

    if (data.success) {
      return data.wishlist.map(JSON.parse); // Returns the array of handles, like ["vintage-chanel"]
    } else {
      console.error("Failed to fetch wishlist:", data.error);
      return [];
    }
  } catch (error) {
    console.error("Network error while fetching wishlist:", error);
    return [];
  }
}

async function syncWishlistToShopify(favorites) {
  localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));

  if (window.customerId) {
    try {
      const response = await fetch(WORKER_BASE_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          customerId: window.customerId,
          handles: favorites.map(JSON.stringify)
        })
      });

      if (response.ok) {
        console.log("Wishlist safely synced to user account!");
      }
    } catch (error) {
      console.error("Failed to sync wishlist", error);
    }
  }
}

async function getFavorites() {
  let localFavorites = localStorage.getItem(FAVORITES_KEY);
  localFavorites = localFavorites ? JSON.parse(localFavorites) : [];

  if (window.customerId) {
    try {
      const favoritesFromAPI = await fetchLiveWishlist(window.customerId)

      localFavorites = favoritesFromAPI;
      if (Array.isArray(localFavorites)) {
        localFavorites = Array.from([...localFavorites, ...favoritesFromAPI]
          .reduce((m, o) => m.set(o.id, o), new Map)
          .values()
        );

        localStorage.setItem(FAVORITES_KEY, JSON.stringify(localFavorites));
      }
    } catch (error) {
      console.log("error is", error);
    }
  }

  return localFavorites;
}

/**
 * @param {{ id: string; title: string; }} product
 */
async function toggleFavorite(product) {
  // if (!window.customerId) {
  //   window.location.href = "/account/login";
  //   return;
  // }

  let favorites = await getFavorites();
  const index = favorites.findIndex((/** @type {{ id: string; }} */ o) => o.id === product.id);

  if (index > -1) {
    favorites.splice(index, 1);
  } else {
    favorites.push(product);
  }

  updateFavoriteButtons(favorites);

  await syncWishlistToShopify(favorites);
}

async function updateFavoriteButtons(favoritesValue) {
  const favorites = Array.isArray(favoritesValue) ? favoritesValue : await getFavorites();
  const buttons = document.querySelectorAll('.favorite-toggle-btn');

  buttons.forEach(button => {
    const id = button.getAttribute('data-product-id');
    const emptyIcon = button.querySelector('.icon-heart-empty');
    const filledIcon = button.querySelector('.icon-heart-filled');

    if (emptyIcon && filledIcon && favorites.findIndex((/** @type {{ id: string | null; }} */ o) => o.id === id) > -1) {
      // @ts-ignore
      emptyIcon.style.display = 'none';
      // @ts-ignore
      filledIcon.style.display = 'block';
      button.classList.add('is-active');
    } else {
      // @ts-ignore
      emptyIcon.style.display = 'block';
      // @ts-ignore
      filledIcon.style.display = 'none';
      button.classList.remove('is-active');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  updateFavoriteButtons();

  document.body.addEventListener('click', async (e) => {
    // @ts-ignore
    const btn = e?.target?.closest('.favorite-toggle-btn');
    if (btn) {
      e.preventDefault();
      const title = btn.getAttribute('data-product-title');
      const id = btn.getAttribute('data-product-id');

      if (id && title) {
        const product = {
          id, title
        }
        await toggleFavorite(product);
      }

      const wishlistGrid = document.getElementById('wishlist-grid');

      if (wishlistGrid) {
        renderWishlist();
      }
    }
  });
});